import React, { useMemo } from "react";

export default function OrderTypesList({ data }) {
  
  const [dine, take] = useMemo(() => {
    const map = Object.fromEntries(
      data.items.map((it) => [it.label.toLowerCase().replace(/\s+/g, ""), it])
    );
    const d =
      map["dine-in"] || map["dinein"] || data.items[0] || { label: "Dine-In", value: 0 };
    const t =
      map["takeaway"] || map["take-away"] || data.items[1] || { label: "Takeaway", value: 0 };
    return [d, t];
  }, [data]);

  const total = (dine?.value || 0) + (take?.value || 0);
  const pctD = total ? Math.round((dine.value / total) * 100) : 0;
  const pctT = total ? 100 - pctD : 0;

  return (
    <>
      <div className="card-title-row">
        <div className="card-title">Order Types</div>
        {/* <div className="card-subtitle">{data.label}</div> */}
      </div>

      <div className="ot3">
 
        <div className="ot3-stats" role="list">
          <div
            className="ot3-item"
            role="listitem"
            aria-label={`${dine.label} ${pctD}%, ${dine.value}`}
          >
            <span className="ot-dot dine" aria-hidden="true" />
            <span className="ot-name">{dine.label}</span>
            <span className="ot-pct">{pctD}%</span>
            <span className="ot-val">{Number(dine.value).toLocaleString()}</span>
          </div>

          <div
            className="ot3-item"
            role="listitem"
            aria-label={`${take.label} ${pctT}%, ${take.value}`}
          >
            <span className="ot-dot take" aria-hidden="true" />
            <span className="ot-name">{take.label}</span>
            <span className="ot-pct">{pctT}%</span>
            <span className="ot-val">{Number(take.value).toLocaleString()}</span>
          </div>
        </div>

        <div className="ot3-rule" aria-hidden="true" />

       
        <div className="ot3-bars" aria-hidden="true">

          <div className="bar-row">
            <div className="bar-track">
              <span className="bar-fill dine" style={{ width: `${pctD}%` }} title={`${dine.label}: ${dine.value}`} />
            </div>
          </div>


          <div className="bar-row">
            <div className="bar-track">
              <span className="bar-fill take" style={{ width: `${pctT}%` }} title={`${take.label}: ${take.value}`} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
